import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import SignUp from "../components/signUp";
import { useAuth } from "../contexts/AuthContext";
import "./Register.scss";

function CreateAccount(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Redirect if already logged in
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from || "/dashboard";
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    document.title = "Create Account - Talsolution";
    return () => {
      document.title = "Talsolution";
    };
  }, []);

  return (
    <>
      <Header />
      <section className="register-page-section">
        <div className="register-page-container">
          <div className="register-page-content">
            <SignUp />
          </div>
        </div>
      </section>
      <Footer />
      <Gotop />
    </>
  );
}

export default CreateAccount;
